import { useTranslation } from 'react-i18next';

// Celulă de semaforizare pentru tabelul raportului ITM.
// Mapează starea de compliance ('ok' | 'missing' | 'partial' | 'na') la un badge colorat.
const STYLES = {
  ok: 'bg-accent-100 text-accent-700 dark:bg-accent-950/50 dark:text-accent-300',
  missing: 'bg-danger-100 text-danger-700 dark:bg-danger-950/50 dark:text-danger-300',
  partial: 'bg-warning-100 text-warning-700 dark:bg-warning-950/50 dark:text-warning-300',
  na: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
};

const SYMBOLS = {
  ok: '✓',
  missing: '✗',
  partial: '○',
  na: '—',
};

const ComplianceCell = ({ status }) => {
  const { t } = useTranslation();
  const s = status || 'na';
  const labelKey = {
    ok: 'globalReports.statusOk',
    missing: 'globalReports.statusMissing',
    partial: 'globalReports.statusPartial',
    na: 'globalReports.statusNa',
  }[s];

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[1.75rem] px-2 py-0.5 rounded-md text-xs font-semibold ${STYLES[s]}`}
      title={t(labelKey)}
    >
      {SYMBOLS[s]}
    </span>
  );
};

export default ComplianceCell;
